import React from 'react'
import styles from './SwatchGroup.module.css'

export default function SwatchGroup({
  mode, // 'color' | 'size'
  label,
  list = [],
  selectedOpt, // size mode 才需要
  value,
  onChange,
  opt = [],
  isPreorder = false,
}) {
  function getSkuParts(skuName) {
    return String(skuName || '')
      .split('*')
      .map((x) => x.trim())
      .filter(Boolean)
  }

  function toSafeNumber(v) {
    const n = Number(v ?? 0)
    return Number.isFinite(n) ? n : 0
  }

  // 判斷選項1是否可選
  const isOption1Disabled = (op1) => {
    const related = opt.filter((o) => String(o.SkuName).startsWith(`${op1}`))

    if (related.length === 0) return true

    return !related.some((o) => {
      const inv = Number(o.InventoryQty ?? 0)
      const price = Number(o.Price ?? 0)

      // 預購商品：不看庫存，只要有價格就可選
      if (isPreorder) {
        return price > 0
      }

      // 一般商品：照原本庫存判斷
      return inv > 0 && price > 0
    })
  }

  // 判斷選項2是否可選
  const isOption2Disabled = (op2) => {
    if (!selectedOpt) return true

    const matched = opt.find((o) => {
      const parts = getSkuParts(o.SkuName)
      const p0 = parts[0] ?? ''
      const p1 = parts[1] ?? ''

      return p0 === selectedOpt && p1 === op2
    })

    if (!matched) return true

    const inv = Number(matched.InventoryQty ?? 0)
    const price = Number(matched.Price ?? 0)

    // 預購商品：不看庫存，只要有價格就可選
    if (isPreorder) {
      return price <= 0
    }

    // 一般商品：照原本庫存判斷
    return inv <= 0 || price <= 0
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.label}>{label}</div>

      <ul className={styles.ul}>
        {list.map((v) => {
          const active = v === value
          const disabled =
            mode === 'op1' ? isOption1Disabled(v) : isOption2Disabled(v)

          return (
            <li key={v} className={styles.li}>
              <button
                type="button"
                className={`${styles.button} ${
                  active ? styles.active : ''
                } ${disabled ? styles.disabled : ''}`}
                disabled={disabled}
                onClick={() => !disabled && onChange?.(v)}
              >
                {v}
              </button>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
